import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRepoCommitsSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_SPACELIFT_VCS_REPO_COMMITS_SUGGESTIONS: TypedDocumentNode<
  {
    searchRepoCommitsSuggestions: SearchSuggestionsOutput;
  },
  QuerySearchRepoCommitsSuggestionsArgs
> = gql`
  query SearchSpaceliftVcsRepoCommitsSuggestions($input: SearchSuggestionsInput!, $repoID: ID!) {
    searchRepoCommitsSuggestions(input: $input, repoID: $repoID) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
